module.exports = __webpack_public_path__ + "img/ico-sabias-que.168a9cf4.png";